import type { ClearRefinementsComponentTemplates } from '../../components/ClearRefinements/ClearRefinements';

const defaultTemplates: ClearRefinementsComponentTemplates = {
  resetLabel: 'Clear refinements',
};

export default defaultTemplates;
